module.exports = __webpack_public_path__ + "static/img/fz_zzb_tb.d987bdf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_zzb_tb.png
// module id = dY2A
// module chunks = 0